import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Agentation } from 'agentation';
import './theme.css';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
    {import.meta.env.DEV && (
      <Agentation
        endpoint={
          window.location.hostname === 'dev.radar.marstein.sk'
            ? 'https://dev.radar.marstein.sk/_agentation'
            : 'http://localhost:4747'
        }
      />
    )}
  </StrictMode>,
);
